module.exports = __webpack_public_path__ + "static/img/car_5.d2a4c67.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/image/car_5.png
// module id = USF0
// module chunks = 1